import { Card, Col, ListGroup, Row } from 'react-bootstrap';
import { CustomText } from 'components/CustomText';
import CustomButton from 'components/CustomButton';
import { isSubstringInArray } from 'helper/formatArray';
import { formatCurrency } from 'helper/formatText';

const OrderSummarySection = ({
  options,
  isMobile,
  totalAmount,
  currencySymbol,
  handlePayment,
  subtotal,
  mov,
  currentDeliveryAddress,
  currentPaymentMethod,
  errors,
  voucherDetails,
  voucherCoversAll,
  currentDeliveryMethod,
  country,
  doorDeliveryFee,
}) => {
  return (
    <>
      <Col md={12}>
        <Card className="border-0 mb-4 mb-lg-0 mb-md-0 mt-4 mt-lg-2">
          <Card.Header>
            <Row>
              <Col>
                <CustomText
                  fontFamily={'Poppins'}
                  fontSize={14}
                  fontWeight={400}
                  textStyle={{
                    textTransform: 'uppercase',
                  }}
                >
                  SUMMARY
                </CustomText>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body className="pt-lg-2 py-0">
            <ListGroup variant="flush">
              {options?.map((x) => (
                <ListGroup.Item
                  className={`${
                    x?.type === 'col' ? 'd-block' : 'd-flex'
                  } align-items-center justify-content-between px-0 py-0 ${
                    x?.className ? x?.className : ''
                  }`}
                  style={
                    x?.style
                      ? { minHeight: 50, ...x?.style }
                      : { minHeight: 50 }
                  }
                >
                  {typeof x?.label === 'string' ? (
                    <CustomText
                      fontFamily={'Poppins'}
                      fontSize={14}
                      fontWeight={400}
                      textClassName={x?.labelClassName}
                      textStyle={x?.labelStyle}
                    >
                      {x?.label}
                    </CustomText>
                  ) : (
                    x?.label
                  )}
                  {typeof x?.value === 'string' ? (
                    <CustomText
                      fontFamily={'Poppins'}
                      fontSize={16}
                      fontWeight={600}
                      textClassName={x?.valueClassName}
                      textStyle={x?.valueStyle}
                    >
                      {x?.value}
                    </CustomText>
                  ) : (
                    x?.value
                  )}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card.Body>
          <Card.Footer>
            <Row>
              <Col
                lg="auto"
                md="auto"
                sm={12}
                className={`${isMobile ? 'rowcentered mb-3' : ''}`}
              >
                <CustomText
                  fontFamily={'Poppins'}
                  fontSize={15}
                  fontWeight={400}
                  text={'TOTAL AMOUNT DUE:'}
                  // cNColor="text-secondary"
                />

                <CustomText
                  fontFamily={'Poppins'}
                  fontSize={20}
                  fontWeight={600}
                  text={formatCurrency(totalAmount, 2, currencySymbol)}
                  cNColor="text-primary"
                />
              </Col>
              <Col className="d-flex align-items-end justify-content-end px-0">
                <CustomButton
                  className={'w-100'}
                  text="Confirm"
                  variant="primary"
                  fontWeight={500}
                  fontSize={14}
                  style={{
                    maxWidth: isMobile ? '100%' : 300,
                    boxShadow:
                      '0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)',
                  }}
                  onClick={handlePayment}
                  disabled={
                    subtotal < mov ||
                    !currentDeliveryAddress ||
                    (currentPaymentMethod?.name?.toLowerCase() == 'pay4me' &&
                      !!errors.pay4MeEmail) ||
                    (!currentPaymentMethod &&
                      !(!!voucherDetails && voucherCoversAll)) ||
                    (isSubstringInArray(currentDeliveryMethod?.name || '#', [
                      'Door',
                    ]) &&
                      isSubstringInArray(country?.name, ['canada']) &&
                      !doorDeliveryFee)
                  }
                />
              </Col>
            </Row>
          </Card.Footer>
        </Card>
      </Col>
    </>
  );
};

export default OrderSummarySection;
